import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {ApiModule, BASE_PATH} from '@irisims/justconsult-api';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {LayoutModule} from '@angular/cdk/layout';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatLegacyButtonModule as MatButtonModule} from '@angular/material/legacy-button';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatIconModule} from '@angular/material/icon';
import {MatLegacyListModule as MatListModule} from '@angular/material/legacy-list';
import {MatLegacyInputModule as MatInputModule} from '@angular/material/legacy-input';
import {MatLegacyFormFieldModule as MatFormFieldModule} from '@angular/material/legacy-form-field';
import {AngularSplitModule} from 'angular-split';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatLegacySelectModule as MatSelectModule} from '@angular/material/legacy-select';
import {MatTreeModule} from '@angular/material/tree';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MAT_DATE_LOCALE, MatNativeDateModule} from '@angular/material/core';
import {MatLegacyTableModule as MatTableModule} from '@angular/material/legacy-table';
import {MatLegacyPaginatorIntl as MatPaginatorIntl, MatLegacyPaginatorModule as MatPaginatorModule} from '@angular/material/legacy-paginator';
import {MatSortModule} from '@angular/material/sort';
import {HttpLoaderFactory, SharedModule} from '@app/shared/shared.module';
import {Configuration, ConfigurationParameters} from '@irisims/justconsult-api';
import {WINDOW_PROVIDERS} from '@app/_helpers/windowsProvider';
import {authInterceptorProviders} from '@app/_helpers/auth.interceptor';
import {CustomMatPaginatorIntl} from '@app/_helpers/customMatPaginatorIntl';
import {MatLegacyDialogModule as MatDialogModule} from '@angular/material/legacy-dialog';
import {MatLegacyProgressBarModule as MatProgressBarModule} from '@angular/material/legacy-progress-bar';

export function apiConfigFactory(): Configuration {
  const params: ConfigurationParameters = {
    basePath: window.location.protocol + '//' + window.location.host,
    // basePath: 'http://172.28.155.204:9080/consult/'
  };
  return new Configuration(params);
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ApiModule.forRoot(apiConfigFactory),
    BrowserAnimationsModule,
    LayoutModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatFormFieldModule,
    MatInputModule,
    AngularSplitModule,
    ReactiveFormsModule,
    FormsModule,
    MatExpansionModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatGridListModule,
    MatSelectModule,
    MatTreeModule,
    MatDatepickerModule,
    MatNativeDateModule,
    TranslateModule.forRoot({
      defaultLanguage: sessionStorage.getItem('lang') ? sessionStorage.getItem('lang') : 'nl',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      isolate: false
    }),
    SharedModule,
    MatDialogModule,
    MatProgressBarModule
  ],
    exports: [MatExpansionModule],
  providers: [
    {provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl},
    WINDOW_PROVIDERS,
    authInterceptorProviders,
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: BASE_PATH, useValue: window.location.protocol + '//' + window.location.host },
  ],

  bootstrap: [AppComponent],
})
export class AppModule {}
